import type { TowerType } from "@mmotdg/shared";
import * as THREE from "three";
import { composeView } from "./core.js";
import type { TowerSkin } from "./types.js";

function defaultBodyGeometry(type: TowerType): THREE.BufferGeometry {
  switch (type) {
    case "archer":
      return new THREE.CylinderGeometry(0.18, 0.3, 0.9, 6);
    case "cannon":
      return new THREE.SphereGeometry(0.4, 16, 12);
    case "frost":
      return new THREE.OctahedronGeometry(0.4, 0);
    case "lightning":
      return new THREE.ConeGeometry(0.3, 0.9, 4);
    case "poison":
      return new THREE.IcosahedronGeometry(0.35, 0);
    case "support":
      return new THREE.TorusGeometry(0.3, 0.1, 8, 16);
    case "antiair":
      return new THREE.CylinderGeometry(0.2, 0.35, 0.7, 8);
    case "economy":
      return new THREE.BoxGeometry(0.5, 0.5, 0.5);
  }
}

const DISPLAY_NAMES: Record<TowerType, string> = {
  archer: "Archer",
  cannon: "Cannon",
  frost: "Frost",
  lightning: "Lightning",
  poison: "Poison",
  support: "Support",
  antiair: "Anti-Air",
  economy: "Sat Mine",
};

function makeDefaultSkin(type: TowerType): TowerSkin {
  return {
    id: "default",
    towerType: type,
    displayName: DISPLAY_NAMES[type],
    build(level, withSelectionRing) {
      return composeView(type, defaultBodyGeometry(type), level, withSelectionRing);
    },
  };
}

export const defaultTowerSkins: Record<TowerType, TowerSkin> = {
  archer: makeDefaultSkin("archer"),
  cannon: makeDefaultSkin("cannon"),
  frost: makeDefaultSkin("frost"),
  lightning: makeDefaultSkin("lightning"),
  poison: makeDefaultSkin("poison"),
  support: makeDefaultSkin("support"),
  antiair: makeDefaultSkin("antiair"),
  economy: makeDefaultSkin("economy"),
};
